import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { LogOut, Sparkles } from "lucide-react";
import { fileUrl } from "@/lib/api";
import NotificationsPopover from "@/components/NotificationsPopover";

export default function TopBar({ tenant, links, unread = 0, onUnreadChange }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const logo = tenant?.logo_path ? fileUrl(tenant.logo_path) : null;

  const handleLogout = async () => {
    await logout();
    if (tenant?.slug) navigate(`/c/${tenant.slug}/login`);
    else navigate("/");
  };

  return (
    <header className="glass-header sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to={tenant?.slug ? `/c/${tenant.slug}/dashboard` : "/"} className="flex items-center gap-3" data-testid="topbar-logo-link">
          {logo ? (
            <img src={logo} alt={tenant.name} className="h-8 w-8 rounded-lg object-cover" />
          ) : (
            <div className="h-8 w-8 rounded-lg bg-mr-primary text-white flex items-center justify-center">
              <Sparkles className="h-4 w-4" />
            </div>
          )}
          <div className="leading-tight">
            <p className="font-display font-semibold text-[15px] text-mr-primary">{tenant?.name || "MedRewards"}</p>
            <p className="text-[10px] uppercase tracking-[0.22em] text-mr-secondary">Loyalty Programme</p>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links?.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="px-4 py-2 text-sm rounded-full text-mr-secondary hover:text-mr-primary hover:bg-[#E2E8F0] transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {user?.role === "patient" && (
            <NotificationsPopover unreadInitial={unread} onChange={onUnreadChange} />
          )}
          {user ? (
            <Button
              data-testid="topbar-logout-btn"
              variant="ghost"
              size="sm"
              onClick={handleLogout}
              className="rounded-full text-mr-primary"
            >
              <LogOut className="h-4 w-4 mr-2" /> Sign out
            </Button>
          ) : (
            <Link to={tenant?.slug ? `/c/${tenant.slug}/login` : "/admin/login"}>
              <Button data-testid="topbar-signin-btn" size="sm" className="rounded-full bg-mr-primary hover:bg-[var(--mr-primary-hover)]">Sign in</Button>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
